import { render, staticRenderFns } from "./improve.vue?vue&type=template&id=5285b4bc&scoped=true&"
import script from "./improve.vue?vue&type=script&lang=js&"
export * from "./improve.vue?vue&type=script&lang=js&"
import style0 from "./improve.vue?vue&type=style&index=0&id=5285b4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5285b4bc",
  null
  
)

export default component.exports